export const FETCH_ADMIN_USER_LIST_REQUEST = "FETCH_ADMIN_USER_LIST_REQUEST";
export const FETCH_ADMIN_USER_LIST_SUCCESS = "FETCH_ADMIN_USER_LIST_SUCCESS";
export const FETCH_ADMIN_USER_LIST_FAILURE = "FETCH_ADMIN_USER_LIST_FAILURE";
export const FETCH_ADMIN_USER_LIST_INITIAL = "FETCH_ADMIN_USER_LIST_INITIAL";
